import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { tap, finalize, share } from 'rxjs/operators';
import { GlobalConsoleService } from './global-console.service';
@Injectable({
  providedIn: 'root'
})
export class AiService {
  readonly baseEndpoint = 'AiController';
  baseUrl = environment.API_URL;

  private messagesSubject = new BehaviorSubject<any[]>([]);
  messages$ = this.messagesSubject.asObservable();

  private fetchingAiResponse = new BehaviorSubject<boolean>(false);
  fetchingAiResponse$ = this.fetchingAiResponse.asObservable();


  constructor(private http: HttpClient, private privilegedAccess: GlobalConsoleService) {}

  getFetchingAiResponse() {
    return this.fetchingAiResponse.getValue();
  }

  setFetchingAiResponse(state: boolean) {
    this.fetchingAiResponse.next(state);
  }

  getMessages() {
    return this.messagesSubject.getValue();
  }

  addMessage(message: any) {
    const current = this.getMessages();
    this.messagesSubject.next([...current, message]);
  }

  setMessages(messages: any[]) {
    this.messagesSubject.next(messages);
  }

  clearMessages() {
    this.messagesSubject.next([]);
  }

  getAiIndexes(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + this.baseEndpoint + '/GetAiIndexes', data);
  }

  send(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + this.baseEndpoint + '/AskByInventoryId', data);
  }

  askByReferenceId(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + this.baseEndpoint + '/AskByReferenceId', data);
  }
  
  getStreamingResponseByReferenceId(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + this.baseEndpoint + '/GetStreamingResponseByReferenceId', data);
  }

  ask(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + this.baseEndpoint + '/Ask', data);
  }

  askAgentStream(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + this.baseEndpoint + '/AskAgentStream', data,
      this.privilegedAccess.privilegedAccessOptions());
  }

  getModels(): Observable<any> {
    return this.http.get<any>(this.baseUrl + this.baseEndpoint + '/GetAiModels');
  }

  getAiResponseByBlueprint(payLoad: any):Observable<any>{
    return this.http.post<any>(this.baseUrl + this.baseEndpoint + '/GetAiResponseByBlueprint', payLoad);
  }

  resetMessages(){
    this.messagesSubject.next([]);
    this.setFetchingAiResponse(false);
  }
  
  getServiceConflictCoPilot(data: any): Observable<any>{
    return this.http.post<any>(this.baseUrl + this.baseEndpoint + '/ServiceConflictCoPilot', data);
  }
}
